import React, { useState } from 'react';

const SetAddressField = ({ isActive, setActive, setHomeAddress, homeAdr }) => {
  const [result, setResult] = useState([]);

  const handleSelect = (value, el) => {
    const { rel, children } = el.props;
    const { lat, lng } = rel;
    const point = {
      value: children,
      lat,
      lng,
    };
    setActive(false);
    mapUtils.getTourstartGeocoder({ id: Type.HOME, lat, lng }, (e) => {
      point.loc = e.data;
      setHomeAddress(point);
    });
    publish(way.DRIVE_CHANGE_CURSOR_ICON, {});
  };
  const update = (list) => {
    setResult((data) => [...list]);
  };
  const searchValue = `${intl.formatMessage({
    id: 'Searching',
    defaultMessage: 'Searching',
  })}...`;
  const handleSearch = (value) => {
    let result = [];
    if (value) {
      if (value.length > 1) {
        result = [{ value: searchValue, data: 555, disabled: true }];
        getTourPointAddress(value, update);
      }
    }
    setResult(result);
  };

  const children = (el, it) => {
    if (el && el.data)
      return (
        <Option key={it} rel={el.data} disabled={el.disabled}>
          {el.value}
        </Option>
      );
  };

  const placeholder = intl.formatMessage({
    id: 'Set HOME address',
    defaultMessage: 'Set HOME address',
  });

  if (isActive) {
    return (
      <AutoComplete
        className="set-home-address-wrapper"
        options={result.map(children)}
        autoFocus
        onSearch={handleSearch}
        onSelect={handleSelect}
        onFocus={() => {
          publish(way.DRIVE_CHANGE_CURSOR_ICON, {
            isEditHome: true,
            id: Type.HOME,
          });
        }}
        onBlur={() => {
          setActive(false);
          setTimeout(() => publish(way.DRIVE_CHANGE_CURSOR_ICON, {}), 500);
        }}
        dropdownMenuStyle={{ maxHeight: 300 }}
        defaultValue={homeAdr}
      >
        <Input
          placeholder={placeholder}
          prefix={() => {
            return null;
          }}
        />
      </AutoComplete>
    );
  }
  return '';
};

export const Actions = ({
  entireTour,
  reverseTour,
  fullScreenMode,
  userHomeAs,
  setHomeAddressUser,
  tourData,
}) => {
  const [isTimeDistEnable, toggleTimeDist] = useState(false);
  const [isTourReversed, setReverseFlag] = useState(false);
  const reverse = () => {
    setReverseFlag(!isTourReversed);
    reverseTour();
  };
  console.log(fullScreenMode);

  const getPDF = () => {
    let href = `https://tourstart.org/api/pdf.pdf?scope=tour&object_id=${tourData.id}`;
    // if(isTimeDistEnable)
    //   href += '&timeT=1';
    if (isTourReversed) href += '&reversT=1';

    window.location.href = href;
  };
  return (
    <div className="action">
      <div className="inviteFriendsDiv">
        <img src="#" alt="inviteFriends" className="inviteFriends" />
      </div>

      <Tooltip
        title={(
          <FormattedMessage
            id="Show the entire Tour on the map"
            defaultMessage="Show the entire Tour on the map"
          />
        )}
      >
        <div className="entireTourDiv" onClick={entireTour}>
          <img src="#" alt="entire" className="entireTour" />
        </div>
      </Tooltip>

      <TimeAndDistanceBetweenPoints
        part={tourData}
        isTimeDistEnable={isTimeDistEnable}
        toggleTimeDist={toggleTimeDist}
        unitsOfLenght={unitsOfLenght}
      />

      <div className="distanceDiv">
        <img src="#" alt="distance" className="distance" />
      </div>

      <Tooltip
        title={
          <FormattedMessage id="Download PDF" defaultMessage="Download PDF" />
        }
      >
        <div className="pdfDiv" onClick={getPDF}>
          <img src="#" alt="pdf" className="pdf" />
        </div>
      </Tooltip>

      {/* <div className="printViewDiv">
            <img src="#" alt="printView" className="printView" />
          </div>
          <div className="reportDiv">
            <img src="#" alt="report" className="report" />
          </div> */}

      <Tooltip
        title={
          <FormattedMessage id="Reverse tour" defaultMessage="Reverse tour" />
        }
      >
        <div className="reverseDiv" onClick={reverse}>
          <img src="#" alt="reverse" className="reverse" />
        </div>
      </Tooltip>

      <div className="gpxEmailDiv">
        <img src="#" alt="gpxEmail" className="gpxEmail" />
      </div>
      <div className="linkDiv">
        <img src="#" alt="link" className="link" />
      </div>
      {/* <div className="embedDiv">
            <img src="#" alt="embed" className="embed" />
          </div> */}
    </div>
  );
};

export const ActionsEdit = React.memo(
  ({
    entireTour,
    reverseTour,
    fullScreenMode,
    userHomeAs,
    setHomeAddressUser,
    tourData,
    homeAddress,
  }) => {
    const [isActiveAddressField, toggleAddressField] = useState(false);
    const [isTimeDistEnable, toggleTimeDist] = useState(false);
    const homeAdr = homeAddress ? homeAddress.value : '';
    return (
      <div className="action">
        <SetAddressField
          isActive={isActiveAddressField}
          setActive={toggleAddressField}
          setHomeAddress={setHomeAddressUser}
          homeAdr={homeAdr}
        />

        <Tooltip
          title={(
            <FormattedMessage
              id="Show the entire Tour on the map"
              defaultMessage="Show the entire Tour on the map"
            />
          )}
        >
          <div className="entireTourDiv" onClick={entireTour}>
            <img src="#" alt="entire" className="entireTour" />
          </div>
        </Tooltip>

        <Tooltip
          title={(
            <FormattedMessage
              id="Full map view"
              defaultMessage="Full map view"
            />
          )}
        >
          <div className="fullMapViewDiv" onClick={fullScreenMode}>
            <img src="#" alt="fullmapView" className="fullMapView" />
          </div>
        </Tooltip>

        <Tooltip
          title={(
            <FormattedMessage
              id="Set your HOME position"
              defaultMessage="Set your HOME position"
            />
          )}
        >
          <div
            className="setHomePositionDiv"
            onClick={() => toggleAddressField(!isActiveAddressField)}
          >
            <img src="#" alt="setHomePosition" className="setHomePosition" />
          </div>
        </Tooltip>

        <TimeAndDistanceBetweenPoints
          part={tourData}
          isTimeDistEnable={isTimeDistEnable}
          toggleTimeDist={toggleTimeDist}
          unitsOfLenght={unitsOfLenght}
        />

        <div className="distanceDiv">
          <img src="#" alt="distance" className="distance" />
        </div>

        <Tooltip
          title={
            <FormattedMessage id="Reverse tour" defaultMessage="Reverse tour" />
          }
        >
          <div className="reverseDiv" onClick={reverseTour}>
            <img src="#" alt="reverse" className="reverse" />
          </div>
        </Tooltip>

        <Tooltip
          title={(
            <FormattedMessage
              id="Use home position as start point"
              defaultMessage="Use home position as start point"
            />
          )}
        >
          <div
            className="homePositionStartDiv"
            onClick={(e) => userHomeAs(Type.START, toggleAddressField)}
          >
            <img
              src="#"
              alt="homePositionStart"
              className="homePositionStart"
            />
          </div>
        </Tooltip>

        <Tooltip
          title={(
            <FormattedMessage
              id="Use home position as end point"
              defaultMessage="Use home position as end point"
            />
          )}
        >
          <div
            className="homePositionEndDiv"
            onClick={(e) => userHomeAs(Type.END, toggleAddressField)}
          >
            <img src="#" alt="homePositionEnd" className="homePositionEnd" />
          </div>
        </Tooltip>

        <div className="faqDiv">
          <img src="#" alt="faq" className="faq" />
        </div>
      </div>
    );
  }
);

const PlaceAction = (props) => {
  return (
    <div className="action">
      This module are developed and will be ready soon
    </div>
    // <ErrorBoundary>
    //   {(props.edit)? <ActionsEdit {...props} /> : <Actions {...props} />}
    // </ErrorBoundary>
  );
};

export default PlaceAction;
